import { AIActionAttributeKind, AIActionContentLengthKind } from "../types/ai-action-context";
import { LanguageCode } from "../types/language";
import { PlanCurrencyKind } from "../types/plan";

export const DEFAULT_REACTIONS = ["😃", "❤️", "😂", "🔥", "💩"];
export const DEFAULT_AI_CONTENT_LENGTH: AIActionContentLengthKind = "short";
export const DEFAULT_AI_ACTION_ATTRIBUTE: AIActionAttributeKind = "original";
export const DEFAULT_LANGUAGE_CODE: LanguageCode = "en-US";
export const DEFAULT_CURRENCY: PlanCurrencyKind = "usd";
